import { DiscoverInstagramCreatorsQuery } from '@frontend/gql/social/graphql';
import { ColumnDefinitionInput } from '../../components/table/types';
import { QueryVariables } from '../../types';

interface useInstagramCreatorSearchTabProps {
  data: DiscoverInstagramCreatorsQuery | undefined;
  clientId: string | undefined | null;
  isLoading: boolean;
  queryVariables: QueryVariables;
  setSelectedColumns: React.Dispatch<React.SetStateAction<ColumnDefinitionInput[]>>;
  selectedColumns: ColumnDefinitionInput[];
  onPageChange: (cursor: string | null, direction: 'next' | 'prev') => void;
  isPaginationFetching: boolean;
}

export const useInstagramCreatorSearchTab = ({
  data,
  clientId,
  isLoading,
  queryVariables,
  setSelectedColumns,
  selectedColumns,
  onPageChange,
  isPaginationFetching,
}: useInstagramCreatorSearchTabProps) => {
  const limit = queryVariables.limit;

  return {
    creatorInstagramCreatorSearchTabProps: {
      data,
      clientId,
      isLoading,
      limit,
      setSelectedColumns,
      selectedColumns,
      onPageChange,
      isPaginationFetching,
    },
  };
};
